import Layout from '../components/layout-alpha'
import FloatButton from '../components/float-button'
import Head from 'next/head'
import Header from '../components/header-menu'
import HeaderPWA from '../components/header'
import { createClient } from 'contentful'
import Image from 'next/image'
import Link from 'next/link'
import { sendMessageApi } from '../lib/api'
import { useRouter } from 'next/router'
/* import FormBottom from '../components/form-bottom' */
import ContactMap from '../components/contact-map'
import { useEffect } from "react";


export default function ContactAlpha({siteEnv, metaDescription = "", websiteUrl ="https://www.alphalives.com/"}) {

    const router = useRouter();
    
    useEffect(() => {
        var onMove = false;
        if(typeof(window) !== "undefined"){
            $ = window.jQuery;
            $(".header").css("opacity",1);
            $("#nav-bar").css("opacity",1);
            $("#contact-intro").find(".digitalisation, .scrollIndicator").css("opacity",1);
            $(".logoBlackLetter").attr("fill", "#333"); // logo
            $("#orange").removeClass("white"); //logo
            $("#grey").removeClass("white"); //logo
            $(".bar").addClass("swap");
            if($(".homeIcon")){
              $(".homeIcon").addClass("black")
            }
                    
            function scrollTo(id){
                if(onMove){
                
                return;
                }else{
                onMove = true;
                $("html,body").animate({
                    scrollTop: $(id).offset().top,
                },0, "easein", function() {
                onMove = false;
                });
                }
            }
            $('.scrollTo').on('click', function (e) {
                if(onMove){
                e.preventDefault();
                return;
                }else{
                onMove = true;
                var position = "";
                position = "#"+ $(this).attr("data-id");
                $("html,body").animate({
                    scrollTop: $(position).offset().top
                },0, function() {
                    onMove = false;
                });
                }
            })
        }
    });

    return(
        <>
            <Layout siteEnv={siteEnv} dontShowFooter={true} >
                <Head>
                    <title>Contact</title>
                    <meta name="description" content={metaDescription} />
                    <meta name="viewport" content="width=device-width,initial-scale=1.0,minimum-scale=1,user-scalable=yes"/>
                    <meta name="robots" content="index, follow"/>
                    <meta property="og:locale" content="fr"/>
                    <meta property="og:site_name" content={siteEnv == "pwafr"? 'progressive-web-apps' : 'alphalives'}/>
                    <meta property="og:type" content={siteEnv == "pwafr"? 'website' : 'article'} />
                    <meta name="og:url" content={websiteUrl+ 'contact'} />
                    <meta property="fb:app_id" content="1795695950672896"/>
                    <meta property="og:title" content="Contact" /> 
                    <meta name="og:description" content={metaDescription} />
                    <meta name="og:image" content={websiteUrl+"img/logo.png"} />
                    <meta name="twitter:card" content="photo"/>
                    <meta name="twitter:site" content={siteEnv == "pwafr"? '@alphalives' : '@alphalives'}/>
                    <meta name="twitter:creator" content={siteEnv == "pwafr"? '@alphalives' : '@alphalives'}/>
                    <meta name="twitter:url" content={websiteUrl+ 'contact'} /> 
                    <meta name="twitter:title" content="Contact" /> 
                    <meta name="twitter:description" content={metaDescription} />
                    <link href={websiteUrl + 'contact'} rel="canonical"/>
                </Head>
                <div className="bg-screen contactMinScreen">
                    {siteEnv == 'alphalives' && <Header />}
                    <ContactMap siteEnv={siteEnv} isContact={true}></ContactMap>
                    {/* <FormBottom siteEnv={siteEnv} isContact={true}></FormBottom> */}
                </div>
            </Layout>
        </>
    );
}